"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseDoStoryStrategy = void 0;
class BaseDoStoryStrategy {
    constructor(doStory) {
        this.doStory = doStory;
    }
}
exports.BaseDoStoryStrategy = BaseDoStoryStrategy;
